import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import settingsReducer from '../reducers/settings';
import worksReducer from '../reducers/works';
import filtersReducer from '../reducers/filters';
import aboutReducer from '../reducers/about';
import contactReducer from '../reducers/contact';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      settings: settingsReducer,
      works: worksReducer,
      filters: filtersReducer,
      about: aboutReducer,
      contact: contactReducer
    }),
    composeEnhancers(applyMiddleware(thunk))
  );

  return store;
};



// WEBPACK FOOTER //
// ./src/store/configureStore.js